var map = {
	"./MdiArrowDownThinCircleOutline.svg": 3595,
	"./MdiChevronDownCircleOutline.svg": 5620,
	"./MdiChevronUpCircleOutline.svg": 7402,
	"./MdiMotionPauseOutline.svg": 1424,
	"./MdiMotionPlayOutline.svg": 4630,
	"./MdiRestart.svg": 4086,
	"./MdiShuffle.svg": 9549,
	"./MdiSpeedometer.svg": 8166,
	"./MdiSpeedometerSlow.svg": 6791,
	"./MdiTableOfContents.svg": 8614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9866;